module.exports = __webpack_public_path__ + "img/1.51367313.png";